import { isThhAvailable } from './tierPositions';
import { TgvTier } from './tiergruppe.model';

/** Like the THH apps: more animals than this are not priced without the underwriter. */
export const MAX_THH_TIERE = 10;

/** The cards before this one already use up the THH animals of its Tierart. */
export const thhLimitReached = (tiere: TgvTier[], tier: TgvTier): boolean =>
  isThhAvailable(tier.tierart) &&
  tiere
    .slice(
      0,
      tiere.findIndex(other => other.cardId === tier.cardId),
    )
    .filter(other => other.tierart === tier.tierart && other.umfang.thh).length >= MAX_THH_TIERE;

/** A card that cannot take THH any more does not keep it, e.g. a new card that has it by default. */
export const withThhLimit = (tiere: TgvTier[]): TgvTier[] =>
  tiere.map(tier =>
    tier.umfang.thh && thhLimitReached(tiere, tier)
      ? { ...tier, umfang: { ...tier.umfang, thh: false } }
      : tier,
  );
